import { GoFwInstance, GoFwInternalInstance } from '@pbl/pbl-react-widgets/lib/widgets/framework';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './i18n';
import * as serviceWorker from './registerServiceWorker';

declare global {
  interface Window {
    go_fw: any;
    po_fw: any;
    goReady: any;
    poReady: any;
    fbAsyncInit: any;
  }
}

window.go_fw = GoFwInstance;
window.po_fw = GoFwInstance;

const rootElement = document.createElement('div');
rootElement.setAttribute('id', 'pbl-app-root');
rootElement.style.display = 'none';
rootElement.style.width = '0px';
rootElement.style.height = '0px';

document.body.appendChild(rootElement);

ReactDOM.render(<React.StrictMode><App goFw={window.go_fw} goFwInternal={GoFwInternalInstance} /></React.StrictMode>, rootElement);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
